import type { IconProps } from './types';
import './icons.css';

export default function MasterCard({
  width,
  height,
  className = '',
}: IconProps): React.JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 18}
      height={height || 11}
      viewBox="0 0 18 11"
      className={`icon icon-mastercard ${className || ''}`}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.926 9.335a5.461 5.461 0 0 1-3.512 1.267C2.424 10.602 0 8.229 0 5.3S2.424 0 5.414 0a5.46 5.46 0 0 1 3.512
        1.266A5.461 5.461 0 0 1 12.437 0c2.99 0 5.414 2.373 5.414 5.3 0 2.929-2.424 5.302-5.414 5.302a5.461 5.461 0 0
        1-3.511-1.267Z"
        fill="#ED0006"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.926 9.336A5.245 5.245 0 0 0 10.828 5.3a5.245 5.245 0 0 0-1.902-4.035A5.46 5.46 0 0 1 12.437 0c2.99 0
        5.414 2.373 5.414 5.3 0 2.929-2.423 5.302-5.413 5.302a5.461 5.461 0 0 1-3.512-1.266Z"
        fill="#F9A000"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.925 9.335a5.245 5.245 0 0 0 1.902-4.034 5.245 5.245 0 0 0-1.902-4.035 5.245 5.245 0 0
        0-1.902 4.035c0 1.615.738 3.062 1.902 4.034Z"
        fill="#FF5E00"
      />
    </svg>
  );
}
